module.exports = function (app) {
	'use strict';
	app.controller('pages.assistEmployees.spendingAccounts', ['$scope', '$rootScope', '$state', '$filter', '$q', 'sessionData', 'services', 'modal', 'employee', 'planAdmin','storage',
		function ($scope, $rootScope, $state, $filter, $q, sessionData, services, modal, employee, planAdmin ,storage) {

			$scope.sidebar = {
				breadCrumb: {
					primary: {
						title: 'Assist Employees',
						state: 'assistEmployees'
					},
					secondary: {
						title: 'Manage Spending Account Elections'
					}
				}
			};

			if (!($state.params.groupNumber && $state.params.umi)) {
				storage.set('thisUmi', '');
				storage.set('thisGroup', '');
				$state.go('assistEmployees');
				
				return;
			}

			var umi = $state.params.umi;
			$scope.groupNumber = $state.params.groupNumber;

			employee.loadSummary($state.params.umi).then(
				function(employee) {
					var fullName = employee.data.subscriber.fullName;
					$scope.employeeName = fullName.first + ' ' + fullName.last;
				}
			);

			var getEditPermission = function(systemDepositIndicator) {
				var groupNumber = $scope.groupNumber;

				var canModifyGroup = planAdmin.canModifyGroupNumber(groupNumber);
				var isBlackedOut = sessionData.entitlements.clientQualifiers.spendingAccountBlackedOut;
				var isIndicated = systemDepositIndicator && systemDepositIndicator.toLowerCase && systemDepositIndicator.toLowerCase() === 'y';

				return canModifyGroup && isIndicated && !isBlackedOut;
			};


			var spaInfo = null;
			var spaInfoReset = null;
			var normalizedOriginalAccountLists = null;
			$scope.spa = true;
			$scope.viewstate = 'loading';

			$q.all({
				vendor: services.eprsvc.spendingAccountVendorsByGroupNumber({ groupNumber: $scope.groupNumber }).fetch(),
				spaInfo: services.eprsvc.spendingAccountInformation({ umi: umi + '0', groupNumber: $scope.groupNumber }).fetch(),
				payClass: services.eprsvc.spendingAccountPayClass().fetch()
			}).then(
				function(response) {
					if (
						response &&
						response.spaInfo &&
						response.vendor &&
						response.payClass &&
						response.spaInfo.data &&
						response.vendor.data &&
                        response.payClass.data &&
						response.spaInfo.data.payload &&
						response.vendor.data.payload &&
                        response.payClass.data.payload &&
						Array.isArray(response.spaInfo.data.payload.spendingAccountLists) &&
						response.spaInfo.data.payload.spendingAccountLists.length > 0
					) {
						// if it is AcclarisRolloutError then we have to make it appropiriate message to the user
						if (response.spaInfo.data.payload.spendingAccountLists[0].accountDescription && 
							response.spaInfo.data.payload.spendingAccountLists[0].accountDescription === 'ACCLARIS_VENDOR') {
							$scope.viewstate = 'AcclarisRolloutError';
						} else {
							$scope.spaInfoPay = response.payClass.data.payload;
							spaInfo = angular.copy(response.spaInfo.data.payload);
							spaInfoReset = angular.copy(response.spaInfo.data.payload);

							normalizeIncomingDates(spaInfo.spendingAccountLists);
							normalizedOriginalAccountLists = angular.copy(spaInfo.spendingAccountLists);

							$scope.editPermission = getEditPermission(spaInfo.systemDepositIndicator);
							$scope.spaInfo = spaInfo;
							$scope.isAlegeus = response.vendor.data.payload == '12';
							$scope.viewstate = 'success';
						}
					}
					else {
						$scope.viewstate = 'error';
					}
				},
				function(err) {
					$scope.viewstate = 'error';
					console.error('spendingAccountInformation().fetch failed with', err);
				}
			);

			$scope.resetSPAInfo = function() {
				var temp = spaInfoReset;
                normalizeIncomingDates(spaInfoReset.spendingAccountLists);
                $scope.spaInfo = temp;
			};


			var isAnnualContributionWithinRange = function(accountList, scope) {
				for (var a = 0; a < accountList.length; ++a) {
					var p = accountList[a];

					for (var i = 0; i < p.spendingAccounts.length; i++) {
						if (p.spendingAccounts[i].status) {
							var totalContribution = Number(p.spendingAccounts[i].employeeAnnualContribution) + Number(p.spendingAccounts[i].employerAnnualContribution) || 0;
							var minContribution = Number(p.spendingAccounts[i].minAnnualContribution) || 0;
							var maxContribution = Number(p.spendingAccounts[i].maxAnnualContribution);

							if (
								maxContribution &&
								(
									totalContribution < minContribution ||
									totalContribution > maxContribution
								)
							) {
								scope.planNameValidation = p.accountDescription;
								scope.minContributionValidation = minContribution;
								scope.maxContributionValidation = maxContribution;
								return false;
							}
							else if (totalContribution < minContribution) {
								scope.planNameValidation = p.accountDescription;
								scope.minContributionValidation = minContribution;
								return false;
							}
						}
					}
				}
				return true;
			};

			$scope.saveSPAInformation = function() {
				var modalScope = $rootScope.$new();
				modalScope.spaInfo = $scope.spaInfo;

				modalScope.annualContributionWithinRange =
					isAnnualContributionWithinRange($scope.spaInfo.spendingAccountLists, modalScope);

				modalScope.updateSPAInfo = function(){
					var payload = angular.copy($scope.spaInfo);

                    for (var m = 0; m < payload.spendingAccountLists.length; ++m) {
                        for (var q = 0; q < payload.spendingAccountLists[m].spendingAccounts.length; q++) {
                            if (!payload.spendingAccountLists[m].spendingAccounts[q].status) {
                                payload.spendingAccountLists[m].spendingAccounts.splice(q, 1);
                            }
                        }
                    }
					for (var i = 0; i < payload.spendingAccountLists.length; ++i) {
						payload.spendingAccountLists[i].spendingAccounts = payload.spendingAccountLists[i].spendingAccounts.filter(function(a) {
							a.beginDate = a.beginDate || '';  //calendar sets these to null, which breaks the comparison
							a.endDate = a.endDate || ''; //calendar sets these to null, which breaks the comparison

							return !(normalizedOriginalAccountLists[i].spendingAccounts.some(function(s) { return angular.equals(a, s); }));
						});
					}
					payload.spendingAccountLists = payload.spendingAccountLists.filter(function(l) { return l.spendingAccounts.length > 0; });
					normalizeOutgoingAccounts(payload.spendingAccountLists);

					modalScope.viewstate = 'loading';
					services.eprsvc.saveSpendingAccountInformation({ umi: umi + '0', groupNumber: $scope.groupNumber }).save({ payload: payload }).then(
						function(response) {
							if (response) { // this seems like it should have more checking going on, but this is how I found it
								modalScope.viewstate = 'success';
							}
						},
						function() {
							modalScope.viewstate = 'error';
						}
					);
				};

				if ($scope.spaInfo) {
					modalScope.viewstate = 'initial';
					modal.open({
						template: require('pages/employee/modals/save-spa-info-modal.html'),
						scope: modalScope
					});
				}
			};


			// hoisted date normalization methods
			function normalizeIncomingDates(spendingAccountLists) {
				var normalize = function(date) {
					return $filter('dateInput')(date);
				};
				spendingAccountLists.forEach(function(spendingAccountObj) {
					spendingAccountObj.spendingAccounts.forEach(function(account) {
						account.spa = true;  // this lets us display a custom message from formValidationGenerator
						account.endDate = normalize(account.endDate);
						account.beginDate = normalize(account.beginDate);
						account.contractBeginDate = normalize(account.contractBeginDate);
						account.contractEndDate = normalize(account.contractEndDate);
					});
				});
			}

			function normalizeOutgoingAccounts(accountList) {
				var normalize = function(date) {
					return $filter('date')(date, 'MM/dd/yyyy');
				};
				accountList.forEach(function(p) {
					for(var i=0; i< p.spendingAccounts.length; i++){
						p.spendingAccounts[i].endDate = normalize(p.spendingAccounts[i].endDate);
						p.spendingAccounts[i].beginDate = normalize(p.spendingAccounts[i].beginDate);
						p.spendingAccounts[i].employerAnnualContribution = p.spendingAccounts[i].employerAnnualContribution || 0;
						delete p.spendingAccounts[i].spa; // undo whatever validation weirdness was done
					}
				});
			}
		}
	]);
};
